/** Linear upload progress — use with `onUploadProgress` from Axios or custom loaders. */
export function UploadProgressBar({
  progress,
  active,
  label = 'Uploading…',
  className = '',
}: {
  progress: number
  active: boolean
  label?: string
  className?: string
}) {
  if (!active) return null
  const pct = Math.min(100, Math.max(0, progress))
  return (
    <div className={className} role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
      <div className="mb-1 flex justify-between text-xs font-medium text-muted-foreground">
        <span>{label}</span>
        <span>{pct}%</span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
        <div
          className="h-full rounded-full bg-primary transition-[width] duration-150 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}
